module.exports = __webpack_public_path__ + "img/doc.cd91e494.svg";